export function getScappCompareKey(value, nivelSeleccionado = "centro") {
  const normalized = String(value ?? "").trim();
  if (!normalized) return "";

  if (nivelSeleccionado === "centro") {
    return normalized.replace(/\s+/g, " ").toLowerCase();
  }

  return normalized;
}

export function isSameScappSelection(a, b, nivelSeleccionado = "centro") {
  return (
    getScappCompareKey(a, nivelSeleccionado) ===
    getScappCompareKey(b, nivelSeleccionado)
  );
}

export function findScappSelectionLabel(
  selectedValue,
  options = [],
  nivelSeleccionado = "centro"
) {
  const match = options.find((option) =>
    isSameScappSelection(option, selectedValue, nivelSeleccionado)
  );

  return match ?? String(selectedValue ?? "");
}
